import { PropertyOrderDTO } from "../DTO/propertyOrderDTO";
import { Address } from "./address";

export class PropertyOrder{
    public id? : number;
    public propertyId! : string;
    public header? : string;
    public address? : Address;
    public imageReference? : string;
    public views? : number;
    public auctionId? : number;
    public auctionType? : number;
    public auctionStatus? : string;
    public soldAt? : Date;
    public sellingPrice? : number;

    constructor(){
    }

    public static mapToDTO(param:PropertyOrder) : PropertyOrderDTO{
        
        let dto = new PropertyOrderDTO();
        try
        {
            dto.id = param.id;
            dto.propertyId = param.propertyId;
            dto.header = param.header;
            if(param.address) dto.address = Address.mapToDTO(param.address);
            dto.imageReference = param.imageReference;
            dto.views = param.views;
            dto.auctionId = param.auctionId;
            dto.auctionType = param.auctionType;
            dto.auctionStatus = param.auctionStatus;
            if(param.soldAt)dto.soldAt = param.soldAt.toISOString();
            dto.sellingPrice = param.sellingPrice;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:PropertyOrderDTO) : PropertyOrder
    {
        
        let obj = new PropertyOrder();
        try
        {
            obj.id = param.id;
            obj.propertyId = param.propertyId;
            obj.header = param.header;
            if(param.address) obj.address = Address.mapFromDTO(param.address);
            obj.imageReference = param.imageReference;
            obj.views = param.views;
            obj.auctionId = param.auctionId;
            obj.auctionType = param.auctionType;
            obj.auctionStatus = param.auctionStatus;
            if(param.soldAt) obj.soldAt = new Date(param.soldAt);
            obj.sellingPrice = param.sellingPrice;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get formattedAddress():string{
        if(!this.address) return '';
        return this.address.streetAddress1 + ', ' + ((this.address.streetAddress2?.length)?(this.address.streetAddress2 +', '):'') + this.address.city + ', ' + this.address.state + ' ' + this.address.zipCode;
    }

    get soldAtUnix():number|undefined{
        if(!this.soldAt) return undefined;
        return this.soldAt?.getTime();
    }

    get status():string[]{
        //the following will need a different logic, once we know more about status
        let result = new Array<string>(0);
        if(this.auctionStatus=="Sale Pending"){
            result.push("Sale Pending");
        }
        if(this.auctionStatus=="Closed"){
            result.push("Closed");
        }
        return result;
    }
}